// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb2082d4","453":"55c15a21","732":"98247e9d"}[chunkId] + ".chunk.js";
};